export default "__VITE_ASSET__k3NJAEGD__"